// Static data for landing page

export const BUNDLES = [
  { qty: 1, label: "1 Pillow", original: 199, price: 147, savings: 52, badge: "Starter", perks: "Try the magic" },
  { qty: 2, label: "2 Pillows", original: 398, price: 187, savings: 211, badge: "Super Deal · Save $211", perks: "Couples' pick · 53% OFF" },
  { qty: 4, label: "4 Pillows", original: 796, price: 297, savings: 499, badge: "Best Deal · 63% OFF", perks: "Family pack · save $499" },
];

export const GALLERY_IMAGES = [
  { src: "/assets/ugc_woman_1.png", alt: "Real customer cuddling Dubai Pillow in bedroom" },
  { src: "/assets/Almohada_1_Mejorada.png", alt: "Dubai Pillow — overhead studio shot" },
  { src: "/assets/ugc_woman_2.png", alt: "Customer falling asleep on Dubai Pillow" },
  { src: "/assets/Almohada_2_Mejorada.png", alt: "Pinch-tuck quilting close-up" },
  { src: "/assets/packaging_1.png", alt: "Luxury Dubai Pillows packaging with swan logo" },
  { src: "/assets/Almohada_3_Mejorada.png", alt: "Two pillows on luxury bed" },
  { src: "/assets/packaging_2.png", alt: "Dubai Pillows box on luxury hotel bed" },
  { src: "/assets/Almohada_5_Mejorada.png", alt: "Queen and King side-by-side" },
];

export const LIFESTYLE = {
  hotelBedroom:
    "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sunriseBedroom:
    "https://images.unsplash.com/photo-1550514704-91c29ba3442a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sleepingPerson:
    "https://images.unsplash.com/photo-1531353826977-0941b4779a1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  darkMarble:
    "https://images.unsplash.com/photo-1550053808-52a75a05955d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const TICKER_QUOTES = [
  "★★★★★  James T. — New York  ·  'I'd stopped looking, honestly. Then I found this.'",
  "★★★★★  Sarah M. — London  ·  'My husband cried. I'm not joking. Best decision I've made.'",
  "★★★★★  Carlos R. — Miami  ·  'Slept better than I did in a $900/night Dubai hotel suite.'",
  "★★★★★  Michelle T. — Sydney  ·  'I've ordered six — one for every person I love.'",
  "★★★★★  David K. — Singapore  ·  'I didn't believe a pillow could change a morning. It can.'",
  "★★★★★  Anna P. — Toronto  ·  'My mum called me crying the next morning. Good tears.'",
];

export const REVIEWS = [
  {
    name: "James T.",
    city: "New York, USA",
    height: "Medium loft",
    quote:
      "I'd honestly stopped looking. I'd accepted that nothing was going to feel different. I was wrong. The first morning I just lay there an extra ten minutes — not because I was tired. Because I didn't want to leave.",
    when: "3 weeks ago",
  },
  {
    name: "Dr. Sarah M.",
    city: "London, UK",
    height: "High loft",
    quote:
      "Two years of physiotherapy for my neck. I'd accepted that mornings would always hurt. They don't. I'm not exaggerating when I say this pillow gave me back something I'd already grieved.",
    when: "1 month ago",
  },
  {
    name: "Carlos R.",
    city: "Miami, USA",
    height: "High loft",
    quote:
      "I stayed at the Burj last spring. I told my wife the room was beautiful but the pillow was something else entirely. We came home, slept on ours, and felt the loss. Found these online. Ordered four without thinking.",
    when: "2 weeks ago",
  },
  {
    name: "Michelle T.",
    city: "Sydney, Australia",
    height: "Medium loft",
    quote:
      "We've slept on the same side of the bed for ten years. Somehow neither of us had ever slept like this. The second night I caught my husband stealing it. We ordered another one before breakfast.",
    when: "5 days ago",
  },
  {
    name: "David K.",
    city: "Melbourne, Australia",
    height: "Medium loft",
    quote:
      "I'm a skeptic. I read marketing copy and roll my eyes. But the 100 nights gave me an out, so I tried it. Three weeks in I realised I hadn't woken at 4 a.m. — not once. That doesn't happen to me.",
    when: "1 month ago",
  },
  {
    name: "Anna P.",
    city: "Manchester, UK",
    height: "High loft",
    quote:
      "I sent one to my mum. She lives alone since dad passed. She called me the next morning and just said 'I slept'. Then she started crying. I cried too. It's just a pillow but it really isn't.",
    when: "2 months ago",
  },
];

export const FAQ = [
  {
    q: "What makes this pillow worth $147?",
    a: "Most pillows ($30–$60) use polyester fill and 180-thread shells that collapse in 6 months. The Dubai Pillow uses 100% Hungarian goose down (800+ fill power — the highest grade), wrapped in 400-thread-count organic Egyptian cotton, hand-stitched for 14 hours across 47 pinch-tuck chambers. It holds its loft for 5+ years. At $0.09 per night over its lifespan, it's actually cheaper than a generic pillow you replace every year.",
  },
  {
    q: "How is each pillow made?",
    a: "Every Dubai Pillow is hand-crafted in our Dubai atelier in 14 hours of patient work: 2h sourcing premium down, 3h cutting and loom-weaving the cotton shell, 5h hand-stitching the 47 pinch-tuck chambers with triple-reinforced seams, 2h triple-washing with plant-based detergents, 1h quality inspection by a master craftsman, and 1h luxury packaging. We only release 200 units per week — that's the maximum our artisans can hand-produce without compromising quality.",
  },
  {
    q: "Is it really organic and hypoallergenic?",
    a: "Yes — fully certified. The down is RDS (Responsible Down Standard) certified from free-range Hungarian geese. The cotton is GOTS-certified organic. Every pillow is triple-washed at 90°C with plant-based detergents and OEKO-TEX® tested to eliminate dust mites, allergens, and any chemical traces. Safe for asthma, eczema, and sensitive skin.",
  },
  {
    q: "What's the difference between Medium and High loft?",
    a: "Every Dubai Pillow is one universal size: 74×48 cm (large hotel format). You only choose the inner loft: Medium (15 cm) for back and stomach sleepers who want a softer, lower profile — or High (18 cm) for side sleepers and taller individuals who need more cervical support. Both have identical 800+ fill power Hungarian goose down. High loft adds +$10 per pillow.",
  },
  {
    q: "How long does shipping take?",
    a: "We process every order in our warehouse within 24–48 hours of purchase. Standard express delivery is 5–7 business days, fully tracked and signed-for. Available in any country, with pre-paid duties included.",
  },
  {
    q: "Will it really fix my neck pain?",
    a: "97% of our customers with chronic neck pain report significant improvement within 14 nights. The 47-chamber pinch-tuck construction keeps your cervical spine in perfect neutral alignment all night — the same engineering recommended by physiotherapists. If it doesn't work for you, we refund every cent within 30 nights, no questions asked.",
  },
  {
    q: "What if I don't like it?",
    a: "Sleep on it for 30 full nights. If you don't love it — email us, we'll refund 100%. No forms, no questions, no return shipping costs. In 6 years, fewer than 1% of customers have ever asked for a refund. You won't be one of them.",
  },
  {
    q: "Why is the 4-pillow bundle 40% off?",
    a: "Because bigger orders are dramatically cheaper for us to produce, pack and ship. We pass the entire savings to you: $796 → $297 (save $499 · 63% off). Most 4-bundle buyers are gifting to family, equipping a guest room, or stocking up at a once-in-a-lifetime price.",
  },
];

export const LIVE_NOTIFS = [
  { name: "Marcus", city: "London", qty: 2, color: "Classic White", height: "High", mins: 3 },
  { name: "Yuki", city: "Tokyo", qty: 1, color: "Premium Grey", height: "Medium", mins: 7 },
  { name: "Elena", city: "Barcelona", qty: 4, color: "Pink Queen", height: "High", mins: 12 },
  { name: "Olivia", city: "Paris", qty: 2, color: "Classic White", height: "Medium", mins: 18 },
  { name: "Hassan", city: "Dubai", qty: 4, color: "Premium Grey", height: "High", mins: 22 },
  { name: "Rachel", city: "Los Angeles", qty: 1, color: "Pink Queen", height: "High", mins: 27 },
  { name: "Takeshi", city: "Osaka", qty: 2, color: "Classic White", height: "Medium", mins: 34 },
  { name: "Sofia", city: "Milan", qty: 2, color: "Pink Queen", height: "High", mins: 41 },
  { name: "James", city: "Toronto", qty: 1, color: "Classic White", height: "Medium", mins: 48 },
  { name: "Priya", city: "Mumbai", qty: 4, color: "Premium Grey", height: "High", mins: 56 },
];

export const FEATURES = [
  {
    icon: "🪶",
    title: "100% Goose Down",
    body:
      "Hand-selected European goose down — the highest fill power available. Cloud-like softness that lasts for years.",
  },
  {
    icon: "🏨",
    title: "7-Star Hotel Grade",
    body:
      "The same construction standard used in the world's finest suites — Burj Al Arab, Emirates Palace, and beyond.",
  },
  {
    icon: "🌿",
    title: "Ethically Sourced",
    body:
      "Our geese are free-range, raised by hand in Europe. Down is collected once per year, humanely, never force-harvested.",
  },
  {
    icon: "🌡️",
    title: "Temperature Regulating",
    body:
      "Natural goose down breathes unlike any synthetic — cool in summer, warm in winter. No more flipping to the cold side.",
  },
  {
    icon: "📐",
    title: "Cervical Alignment",
    body:
      "Pinch-tuck quilting maintains consistent loft. Your neck stays in perfect neutral alignment throughout the night.",
  },
  {
    icon: "♾️",
    title: "Never Goes Flat",
    body:
      "The pinch-tuck construction traps air permanently in each section. This pillow holds its shape for 5+ years — guaranteed.",
  },
];

export const PAINS = [
  {
    img: "https://images.unsplash.com/photo-1531353826977-0941b4779a1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "You Wake Up Exhausted. Every. Single. Day.",
    body:
      "A collapsed pillow tilts your cervical spine up to 14° out of neutral alignment. Your brain never reaches deep REM sleep. You sleep 8 hours and still wake up tired — because the pillow is working against you, not for you.",
  },
  {
    img: "https://images.unsplash.com/photo-1559757175-5700dde675bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Neck Pain, Shoulder Tension, and Headaches Before 9AM.",
    body:
      "Your neck muscles spend all night compensating for a pillow that can't hold its shape. By morning, the damage is done. This isn't a medical problem — it's a pillow problem. And it has a $147 solution.",
  },
  {
    img: "https://images.unsplash.com/photo-1520206183501-b80df61043c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "You Toss and Turn All Night Looking for the Cool Side.",
    body:
      "Synthetic pillows trap heat and compress under pressure. Premium goose down breathes naturally — staying cool, staying lofted, adapting to your position all night. That's the difference between sleep and real sleep.",
  },
];
